var esntialEligibilityFetcher = async (service, payloadItems) => {
  let payloadOptions;
  if (typeof payloadItems === 'string') {
    const options = {
      body: {
        ids: [payloadItems],
        statusArray: ['Available']
      },
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'omit',
      method: 'POST'
    };
    options.body = JSON.stringify(options.body);
    payloadOptions = options;
  } else {
    const {
      vin,
      ownerId,
      year,
      make,
      model,
      trim,
      mileage,
      vehicleCondition,
      listingPrice,
      msrp,
      isCertified
    } = payloadItems;
    const optionsV2 = {
      body: [{
        certifiedUsed: isCertified,
        condition: vehicleCondition ? vehicleCondition.charAt(0).toUpperCase() + vehicleCondition.slice(1) : '',
        dealerId: ownerId?.toString(),
        make,
        mileage: mileage ? parseInt(mileage, 10) : 0,
        model,
        msrp,
        sellingPrice: listingPrice,
        trim,
        year,
        vin
      }],
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'omit',
      method: 'POST'
    };
    optionsV2.body = JSON.stringify(optionsV2.body);
    payloadOptions = optionsV2;
  }
  const response = await fetch(service, payloadOptions).catch(error => {
    // eslint-disable-next-line no-console
    console.log('Esntial Eligibility API call failed', error);
  });
  if (response) {
    const json = await response.json();
    return json;
  }
  return {};
};
export { esntialEligibilityFetcher as default };
